import { render, staticRenderFns } from "./BsFarmModule01.vue?vue&type=template&id=19e26525&scoped=true"
import script from "./BsFarmModule01.vue?vue&type=script&lang=js"
export * from "./BsFarmModule01.vue?vue&type=script&lang=js"
import style0 from "./BsFarmModule01.vue?vue&type=style&index=0&id=19e26525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e26525",
  null
  
)

export default component.exports